export default __webpack_public_path__ + "static/media/deliland-cane-icon.6d6a0b8e.png";